import { render, staticRenderFns } from "./duplicate-dialog.vue?vue&type=template&id=aa8e4e32&"
import script from "./duplicate-dialog.vue?vue&type=script&lang=js&"
export * from "./duplicate-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports